import React, { useRef, useState, useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import css from 'classnames';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import {
  Grid,
  Typography,
  ButtonGroup,
  FormControl,
  InputLabel,
  MenuItem,
} from '@material-ui/core';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import { useDropzone } from 'react-dropzone';
import Draggable from 'react-draggable';
import DownloadIcon from '@mui/icons-material/Download';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import qs from 'query-string';

import { contractInputTypes } from 'constants/contracts';
import { getCreators as getCreatorsSlice, creatorsSelector } from 'slices/user';
import {
  createContract as createContractSlice,
  createContractsSelector,
} from 'slices/contracts';
import { setHeaderData } from 'slices/misc';
import { getPaymentGroups, paymentGroupsSelector } from 'slices/paymentGroups';
import global from 'styles/global';
import Button from 'components/Button';
import TableHeader from 'components/TableHeader';
import LoadingOverlay from 'components/LoadingOverlay';
import { formatCreatorName, formatCustomerName } from 'util/renderStrings';
import Card from 'components/Card';
import PlainDocument from './PlainDocument';
import {
  contractTemplatesSelector,
  getContractTemplates as getContractTemplatesSlice,
} from 'slices/contractTemplates';
import { contractTypes } from 'constants/contracts';
import {
  customersSelector,
  getCustomers as getCustomersSlice,
} from 'slices/customers';
import Autocomplete from 'components/Autocomplete';
import TextField from 'components/TextField';
import Select from 'components/Select';

const TWENTY_FIVE_MB = 25 * 1000 * 1000;

const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: 0,
    padding: theme.spacing(2),
  },
  docHeader: {
    paddingBottom: '0 !important',
    marginBottom: '-12px',
  },
  dropzone: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(8),
    borderWidth: '2px',
    borderRadius: 0,
    borderColor: theme.palette.shades.charcoal036,
    borderStyle: 'dashed',
    backgroundColor: theme.palette.shades.charcoal004,
    color: theme.palette.shades.charcoal036,
    outline: 'none',
    transition: 'border 0.24s ease-in-out',
  },
  dropzoneContainer: {
    padding: theme.spacing(3),
  },
  sigBlock: {
    position: 'absolute',
    cursor: 'move',
    color: 'red',
    maxWidth: '215px',
    borderRadius: '5px',
    margin: 'auto',
    userSelect: 'none',
  },
  sigContainer: {
    height: '120px',
  },
  docContainer: {
    border: '1px solid black',
  },
  flowRoot: {
    display: 'flow-root',
  },
  removeSig: {
    position: 'absolute',
    top: -20,
    right: -20,
  },
  pdfCtrBar: {
    padding: theme.spacing(1, 2, 0, 2),
  },
}));

const NewContract = ({
  creatorsState,
  getCreators,
  createContract,
  createContractsState,
  contractTemplatesState,
  getContractTemplates,
  getCustomers,
  customersState,
}) => {
  const classes = useStyles();
  const g = global();
  const history = useHistory();
  const dispatch = useDispatch();

  const { campaignId } = qs.parse(history.location.search);

  const { data: campaigns, loading: campaignsLoading } = useSelector(
    paymentGroupsSelector
  );
  const { data: creators, loading: creatorsLoading } = creatorsState;
  const { data: customers, loading: customersLoading } = customersState;
  const { data: contractTemplates, loading: contractTemplatesLoading } =
    contractTemplatesState;
  const loading =
    creatorsLoading ||
    contractTemplatesLoading ||
    customersLoading ||
    campaignsLoading;

  const { loading: createContractsLoading } = createContractsState;

  useEffect(() => {
    dispatch(
      setHeaderData({
        title: 'New Contract',
        breadcrumbs: [
          { label: 'Creator Pay', link: '/' },
          { label: 'Contracts', link: '/contracts' },
          { label: 'New Contract' },
        ],
      })
    );

    dispatch(getPaymentGroups());
    getCreators();
    getContractTemplates();
    getCustomers();
  }, []);

  const [isHelloSign, setIsHelloSign] = useState(false);
  const [title, setTitle] = useState('');
  const [recipientInput, setRecipientInput] = useState('');
  const [recipient, setRecipient] = useState();
  const [campaign, setCampaign] = useState('');
  const [template, setTemplate] = useState();
  const [file, setFile] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [numPages, setNumPages] = useState(null);
  const [dropErr, setDropErr] = useState('');
  const [expDate, setExpDate] = useState(new Date());
  const [recipientType, setRecipientType] = useState('creator');

  //state for PlainDocument
  const [plainFile, setPlainFile] = useState();

  // When the page loads, we might have a payment_group_id specified in the query parameters, so we make
  // an object like so: { id: payment_group_id }, but when the campaign details are fetched we need to
  // update the selection so the autocomplete has the real selection, which renders title and everything
  // useEffect(() => {
  //   if (payments.length === 0 || paramIsUsed) return;
  //   const { group = {}, recipient = {} } = payments[0];
  //   if (!group?.title && !!payment_group_id) {
  //     const newGroup = paymentGroups.find((grp) => grp.id === payment_group_id);
  //     !!newGroup && updateProp(0, newGroup, 'group');
  //     setParamIsUsed(true);
  //   } else if (!recipient?.first_name && !!creator_id) {
  //     const newCreator = creators.find((crtr) => crtr.id === creator_id);
  //     !!newCreator && updateProp(0, newCreator, 'recipient');
  //     setParamIsUsed(true);
  //   }
  // }, [payment_group_id, paymentGroups, payments, creators]);

  const { acceptedFiles, fileRejections, getRootProps, getInputProps } =
    useDropzone({ accept: 'application/pdf', maxSize: TWENTY_FIVE_MB });
  const {
    acceptedFiles: acceptedFilesPlain,
    getRootProps: getRootPropsPlain,
    getInputProps: getInputPropsPlain,
  } = useDropzone({ accept: 'application/pdf', maxSize: TWENTY_FIVE_MB });

  useEffect(() => {
    if (!!campaignId) {
      const defaultCampaign =
        campaigns.find((campaign) => campaign.id === campaignId) || {};
      setCampaign(defaultCampaign);
    }
  }, [campaigns, campaignId]);

  useEffect(() => {
    const newFile = acceptedFiles[0];
    if (!newFile) return;
    setFile({
      file: newFile[0],
      preview: URL.createObjectURL(newFile),
    });
    setDropErr('');
  }, [acceptedFiles]);

  useEffect(() => {
    if (fileRejections.length > 0) {
      setDropErr('Contract must be a PDF under 25 MB');
    }
  }, [fileRejections]);

  const docRef = useRef();
  const sigRef = useRef();
  const doc = docRef.current;
  const sig = sigRef.current;

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const [lastSigId, setLastSigId] = useState(0);
  const [sigBlocks, setSigBlocks] = useState([
    { id: 0, x: 0, y: 0, pristine: true },
  ]);

  const trackPos = (data, id) => {
    const sigBlock = sigBlocks.find((sb) => sb.id === id);
    if (!sigBlock) return;

    const newSigBlocks = sigBlocks.map((sb) => {
      if (sb.id === id) {
        return {
          ...sb,
          page: pageNumber,
          x: data.x,
          y: data.y,
          pristine: false,
        };
      }
      return sb;
    });
    if (sigBlock.pristine) {
      setSigBlocks([
        ...newSigBlocks,
        { id: lastSigId + 1, x: 0, y: 0, pristine: true },
      ]);
      setLastSigId(lastSigId + 1);
    } else {
      setSigBlocks(newSigBlocks);
    }
  };

  const createContractAndNavigate = async () => {
    const sigs = sigBlocks
      .filter((sb) => !sb.pristine)
      .map((sb) => {
        const d1 = sig.offsetLeft - doc.offsetLeft + sb.x;
        const d2 = sig.offsetTop - doc.offsetTop + sb.y;

        // This is assuming that the document is the standard A4 size, PDFs are measured in points, A4 width/ height at 72 PPI = 612 pts x 792 pts
        const xPts = (d1 / doc.offsetWidth) * 612;
        const yPts = (d2 / doc.offsetHeight) * 792;
        return {
          x: Math.round(xPts),
          y: Math.round(yPts),
          type: contractInputTypes.signature,
          width: 80,
          height: 16,
          required: true,
          signer: 0,
          api_id: `signature_field_${sb.id}`,
          page: sb.page,
        };
      });
    const formData = new FormData();
    formData.append('formFields', JSON.stringify(sigs));
    if (acceptedFiles.length > 0) {
      formData.append('file', acceptedFiles[0], acceptedFiles[0].name);
    }
    formData.append('title', title);
    formData.append('recipient', recipient.id);
    formData.append('recipient_type', recipientType);
    formData.append('payment_group_id', campaign ? campaign.id : '');
    formData.append('expiration_date', expDate);
    formData.append('template_id', template?.hellosign_template_id || '');
    formData.append('type', contractTypes.HelloSign);
    createContract(formData, () => history.push('/contracts'));
  };

  const createPlainContractAndNavigate = async () => {
    const formData = new FormData();
    formData.append('file', acceptedFilesPlain[0], acceptedFilesPlain[0].name);
    formData.append('title', title);
    formData.append('recipient', recipient.id);
    formData.append('recipient_type', recipientType);
    formData.append('payment_group_id', campaign ? campaign.id : '');
    formData.append('expiration_date', expDate);
    formData.append('type', contractTypes.Uploaded);
    createContract(formData, () => history.push('/contracts'));
  };

  const removeIfOutsideDoc = (data, id) => {
    if (!sig || !doc) return;
    const sigBlock = sigBlocks.find((sb) => sb.id === id);
    const d1 = sig.offsetLeft - doc.offsetLeft + sigBlock.x + 16;
    const d2 = sig.offsetTop - doc.offsetTop + sigBlock.y;
    if (
      d1 < 0 ||
      d1 > doc.offsetWidth - 112 || // 32 for padding of container element, 80 for width of sig block
      d2 < 0 ||
      d2 > doc.offsetHeight - 32 // 16 for height of sig block, 16 for container element padding
    ) {
      handleDelete(id);
    }
  };

  const handleDelete = (id) => {
    const newSigBlocks = sigBlocks.filter((sb) => sb.id !== id);
    setSigBlocks(newSigBlocks);
  };

  const handleNextPage = () => {
    setPageNumber(Math.min(numPages, pageNumber + 1));
  };

  const handleBackPage = () => {
    setPageNumber(Math.max(1, pageNumber - 1));
  };

  const clearFile = () => {
    setFile(null);
    setSigBlocks(sigBlocks.slice(-1));
  };

  const handleRecipientChange = (_, value) => {
    setRecipient(value);
    if (!!value) setRecipientInput(formatCreatorName(value));
  };

  const handleRecipientInputChange = (_, val) => {
    setRecipientInput(val);
  };

  const isValid = !isHelloSign
    ? title !== '' && !!recipient && !!plainFile
    : title !== '' && !!recipient && (!!file || !!template);

  return (
    <div>
      <LoadingOverlay open={loading} />

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TableHeader title="Contract details">
            <div>
              <Button
                size="small"
                onClick={
                  isHelloSign
                    ? createContractAndNavigate
                    : createPlainContractAndNavigate
                }
                variant="contained"
                color="primary"
                loading={createContractsLoading}
                disabled={!isValid}
              >
                Create Contract
              </Button>
            </div>
          </TableHeader>

          <Card noHeader>
            <Grid container spacing={3} className={g.mt_sm}>
              {/* The option to use hellosign/ legally binding contracts is deprecated, leaving this here in case we bring it back - James */}
              {/* <Grid item sm={12}>
                <Typography variant="h5" className={g.mb_xs}>
                  Select one
                </Typography>
                <ButtonGroup variant="outlined">
                  <Button
                    color="primary"
                    variant={isHelloSign ? 'contained' : 'outlined'}
                    onClick={() => setIsHelloSign(true)}
                  >
                    Use Hello Sign
                  </Button>
                  <Button
                    color="primary"
                    variant={!isHelloSign ? 'contained' : 'outlined'}
                    onClick={() => setIsHelloSign(false)}
                  >
                    Upload Contract
                  </Button>
                </ButtonGroup>
                <Typography variant="body2" className={g.mt_xs}>
                  {isHelloSign
                    ? `We'll send a Contract to the recipient via HelloSign to be signed. This is a legally binding Contract.`
                    : `You'll upload a copy of a document that's already been signed. No notification will be sent out.`}
                </Typography>
              </Grid> */}

              <Grid item md={4} sm={12}>
                <TextField
                  size="small"
                  className={g.m_zero}
                  variant="outlined"
                  label="Title"
                  required
                  value={title}
                  onChange={(evt) => setTitle(evt.target.value)}
                  fullWidth
                />
              </Grid>

              <Grid item md={4} sm={12}>
                <FormControl
                  size="small"
                  variant="outlined"
                  className={g.full_width}
                >
                  <InputLabel id="select-recipient-type-label">
                    Recipient Type
                  </InputLabel>
                  <Select
                    labelId="select-recipient-type-label"
                    label="Recipient Type"
                    id="select-recipient-type"
                    value={recipientType}
                    onChange={(evt) => setRecipientType(evt.target.value)}
                  >
                    <MenuItem value="creator">Creator</MenuItem>
                    <MenuItem value="customer">Customer</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item md={4} sm={12}>
                <Autocomplete
                  className={g.mb_zero_i}
                  options={recipientType === 'creator' ? creators : customers}
                  getOptionLabel={
                    recipientType === 'creator'
                      ? formatCreatorName
                      : formatCustomerName
                  }
                  value={recipient}
                  inputValue={recipientInput}
                  onChange={handleRecipientChange}
                  onInputChange={handleRecipientInputChange}
                  textInputProps={{
                    label: 'Recipient',
                    required: true,
                  }}
                />
              </Grid>

              <Grid item md={4} sm={12}>
                <Autocomplete
                  className={g.mb_zero_i}
                  options={campaigns}
                  getOptionLabel={(option) => `${option.title || ''}`}
                  getOptionSelected={(option, value) => option.id === value.id}
                  value={campaign}
                  onChange={(_, val) => setCampaign(val)}
                  textInputProps={{
                    label: 'Campaign',
                  }}
                />
              </Grid>

              <Grid item md={4} sm={12}>
                <TextField
                  InputLabelProps={{
                    shrink: true,
                  }}
                  className={css(g.mt_zero_i, g.mb_md_i)}
                  variant="outlined"
                  label="Expiration date"
                  type="date"
                  fullWidth
                  margin="dense"
                  value={expDate}
                  onChange={(evt) => setExpDate(evt.target.value)}
                />
              </Grid>

              {isHelloSign && (
                <Grid item md={4} sm={12}>
                  <Autocomplete
                    className={css(g.mt_zero, g.mb_md_i)}
                    options={contractTemplates}
                    getOptionLabel={(option) => `${option.title || ''}`}
                    value={template}
                    onChange={(_, val) => setTemplate(val)}
                    textInputProps={{
                      label: 'Template',
                    }}
                  />
                </Grid>
              )}
            </Grid>
          </Card>
        </Grid>

        <Grid item xs={12} className={classes.docHeader}>
          <TableHeader title="Add a document"></TableHeader>
        </Grid>

        {isHelloSign && !template && (
          <>
            <Grid item sm={9} xs={12}>
              <Card noHeader>
                {!file && (
                  <section className={classes.dropzoneContainer}>
                    <div {...getRootProps({ className: classes.dropzone })}>
                      <input {...getInputProps()} />
                      <AddIcon
                        style={{ fontSize: 60 }}
                        className={g.charcoal036}
                      />
                      <Typography variant="body1">
                        Drag and drop a PDF to get started
                      </Typography>
                    </div>
                    <aside>
                      <Typography
                        variant="body1"
                        className={css(g.error, g.mt_sm)}
                      >
                        {dropErr}
                      </Typography>
                    </aside>
                  </section>
                )}
                {!!file && (
                  <>
                    <div
                      className={css(
                        classes.pdfCtrBar,
                        g.flexRowSpacing,
                        g.alignCenter
                      )}
                    >
                      <div className={css(g.alignCenter, g.flexRow)}>
                        <Typography variant="body2" className={g.alignStart}>
                          Page {pageNumber} of {numPages}
                        </Typography>
                        <Button
                          disabled={pageNumber === 1}
                          onClick={handleBackPage}
                        >
                          Back
                        </Button>
                        <Button
                          onClick={handleNextPage}
                          disabled={pageNumber === numPages}
                        >
                          Next
                        </Button>
                      </div>
                      <CloseIcon
                        className={css(g.clickable, g.error)}
                        onClick={clearFile}
                      />
                    </div>
                    <div className={classes.flowRoot} ref={docRef}>
                      <Document
                        file={file.preview}
                        onLoadSuccess={onDocumentLoadSuccess}
                        className={css(classes.docContainer, g.m_md, g.mt_zero)}
                      >
                        <Page pageNumber={pageNumber} />
                      </Document>
                    </div>
                  </>
                )}
              </Card>
            </Grid>

            <Grid item sm={3} xs={12}>
              <Card noHeader>
                <Grid container>
                  <Grid item xs={12} className={g.mb_md}>
                    <Typography variant="h3">Signature blocks</Typography>
                    <Typography variant="subtitle2">Drag to add</Typography>
                  </Grid>

                  <Grid item xs={6} className={classes.sigContainer}>
                    <div ref={sigRef}>
                      {sigBlocks.map((sigBlock) => (
                        <Draggable
                          key={`sigBlock-${sigBlock.id}`}
                          disabled={!file}
                          onStop={(e, data) =>
                            removeIfOutsideDoc(data, sigBlock.id)
                          }
                          onDrag={(e, data) => trackPos(data, sigBlock.id)}
                        >
                          <div
                            className={css(
                              classes.sigBlock,
                              g.centerChildren,
                              g.bg_sigYellow,
                              g.p_xs,
                              sigBlock.page === pageNumber ||
                                sigBlock.page === undefined
                                ? undefined
                                : g.hide
                            )}
                          >
                            <DownloadIcon />
                            {!sigBlock.pristine && (
                              <CloseIcon
                                onClick={() => handleDelete(sigBlock.id)}
                                className={css(
                                  g.clickable,
                                  g.error,
                                  classes.removeSig
                                )}
                              />
                            )}
                            <Typography variant="subtitle2">
                              Signature
                            </Typography>
                            {/* <div>
                        x: {sigBlock.x.toFixed(0)}, y: {sigBlock.y.toFixed(0)}
                      </div> */}
                          </div>
                        </Draggable>
                      ))}
                    </div>
                  </Grid>
                  <Grid item xs={6}>
                    {/* TODO: add initials */}
                    {/* <Draggable onDrag={(e, data) => trackPos(data)}>
                  <div
                    className={css(
                      classes.sigBlock,
                      g.centerChildren,
                      g.bg_sigYellow,
                      g.p_xs
                    )}
                  >
                    <DownloadIcon />
                    <Typography variant="subtitle2">Initial</Typography>
                  </div>
                </Draggable> */}
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </>
        )}

        {isHelloSign && !!template && (
          <Grid item xs={12}>
            <Card noHeader>
              <Typography variant="h5">
                Document specified by template.
              </Typography>
            </Card>
          </Grid>
        )}

        {!isHelloSign && (
          <PlainDocument
            acceptedFiles={acceptedFilesPlain}
            getRootProps={getRootPropsPlain}
            getInputProps={getInputPropsPlain}
            plainFile={plainFile}
            setPlainFile={setPlainFile}
          />
        )}
      </Grid>
    </div>
  );
};

const mapStateToProps = (state) => ({
  creatorsState: creatorsSelector(state),
  createContractsState: createContractsSelector(state),
  contractTemplatesState: contractTemplatesSelector(state),
  customersState: customersSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  getCreators: () => dispatch(getCreatorsSlice()),
  createContract: (data, cb) => dispatch(createContractSlice(data, cb)),
  getContractTemplates: () => dispatch(getContractTemplatesSlice()),
  getCustomers: () => dispatch(getCustomersSlice()),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewContract);
